/* Keep Going — shared selling-plan helpers for the buy surfaces
   (kg-main-product, kg-case-builder). One implementation; both sections
   consume it. Loaded from theme.liquid. */
window.KgPlans = {
  /* parse a data-attribute JSON array of {id, name, price-cents}; [] on garbage */
  parse: function (json) {
    if (!json) return [];
    try {
      var list = JSON.parse(json);
      return Array.isArray(list) ? list : [];
    } catch (err) {
      return [];
    }
  },

  /* find a plan by its display name */
  byName: function (json, name) {
    return this.parse(json).find(function (p) { return p.name === name; }) || null;
  },

  /* find a plan by id */
  byId: function (json, id) {
    return this.parse(json).find(function (p) { return String(p.id) === String(id); }) || null;
  },

  /* build <option> elements for a select from a plans json */
  options: function (json) {
    return this.parse(json).map(function (p) {
      return '<option value="' + String(p.name).replace(/"/g, '&quot;') + '" data-id="' + p.id + '" data-cents="' + p.price + '">' + p.name + '</option>';
    }).join('');
  },

  /* human cadence phrase from a plan name:
     "Every 2 Weeks" -> "every 2 weeks", "Weekly Subscription" -> "every week" */
  phrase: function (name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('every') === 0) return n;
    if (n.indexOf('biweek') > -1 || n.indexOf('2 week') > -1) return 'every 2 weeks';
    if (n.indexOf('3 week') > -1) return 'every 3 weeks';
    if (n.indexOf('week') > -1) return 'every week';
    if (n.indexOf('month') > -1) return 'every month';
    return n;
  }
};
